import { $3l5vvh8yg0ier as $ } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.v4u_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.s4u_1;
    if (index >= interceptors.q2()) {
      $this.w4u();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.v4u_1 = index + 1 | 0;
    yield* $(executeInterceptor($this, $this.u4u_1, $completion), $completion);
  }
   while (true);
  return $this.u4u_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.s4u_1 = interceptors;
        this.t4u_1 = coroutineContext;
        this.u4u_1 = subject;
        this.v4u_1 = 0;
      }
      ww() {
        return this.t4u_1;
      }
      x4u() {
        return this.u4u_1;
      }
      w4u() {
        this.v4u_1 = -1;
      }
      *y4u(subject, $completion) {
        this.u4u_1 = subject;
        return yield* this.z4u($completion);
      }
      *z4u($completion) {
        var index = this.v4u_1;
        if (index < 0)
          return this.u4u_1;
        if (index >= this.s4u_1.q2()) {
          this.w4u();
          return this.u4u_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *a4v(initial, $completion) {
        this.v4u_1 = 0;
        this.u4u_1 = initial;
        return yield* this.z4u($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
